<template>
  <div class="px-6">
    <!-- LOADING DATA -->
    <LoadingPage v-if="loading"></LoadingPage>
    <!-- COMPLETE VIEW -->
    <div v-else>
      <InfoCreatingClient
        v-if="selectedClient.stackstatus == 'CREATING'"
        :clientInfo="selectedClient"
      ></InfoCreatingClient>
      <div v-else>
        <ClientInfo class="mb-6"></ClientInfo>
        <ClientAttributes></ClientAttributes>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingPage from "../components/common/LoadingPage.vue";
import InfoCreatingClient from "../components/common/InfoCreatingClient.vue";
import ClientInfo from "../components/Home/ClientInfo.vue";
import ClientAttributes from "../components/Home/ClientAttributes.vue";

export default {
  name: "Dashboard",

  components: {
    LoadingPage,
    InfoCreatingClient,
    ClientInfo,
    ClientAttributes,
  },

  data() {
    return {
      loading: false,
    };
  },

  created() {
    this.$store.dispatch("fetch_clients");
  },

  computed: {
    selectedClient() {
      return this.$store.getters.selectedClient;
    },
  },

  watch: {
    selectedClient(nVal, oVal) {
      if (nVal.id !== oVal.id) {
        this.fetchData();
      }
    },
  },

  methods: {
    async fetchData() {
      this.loading = true;
      await this.$store.dispatch("fetch_attributes");
      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
